export const topicOptions = [
  "Informal recycling",
  "Blood lead levels",
  "Soil and dust contamination",
  "Occupational exposure",
  "Child health",
  "Secondary smelting",
  "Environmental remediation",
  "Global burden",
  "Policy and regulation",
  "Extended producer responsibility",
  "Collection systems",
  "Supply chain accountability"
];

export const policyTagOptions = [
  "Remediation",
  "Enforcement",
  "Worker protection",
  "Facility standards",
  "EPR",
  "Collection incentives",
  "Import/export controls",
  "Public health surveillance",
  "Community screening",
  "Financing"
];

export const populationOptions = [
  "Children",
  "Workers",
  "Nearby residents",
  "Informal recyclers",
  "Pregnant people",
  "General population"
];

export const exposurePathwayOptions = [
  "Blood lead",
  "Soil/dust",
  "Air emissions",
  "Occupational",
  "Community exposure",
  "Residential contamination",
  "Food/water",
  "Process emissions"
];

export const statusOptions = ["new", "ai_tagged", "needs_review", "approved", "excluded"];

export const sourceTypeOptions = ["journal", "report", "policy", "dataset", "guidance"];

export const evidenceTypeOptions = [
  "case investigation",
  "cross-sectional study",
  "review",
  "modeling",
  "intervention evaluation",
  "environmental sampling",
  "policy analysis",
  "guidance"
];
